<template>
  <div v-if="providers.length" class="social-buttons">
    <button v-if="providers.includes('google')" type="button" class="pop-auth__btn pop-auth__btn--secondary" :disabled="busy" data-test="google-button" @click="google">
      <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.5 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.8 6C12.3 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4 7.1-10 7.1-17.5z"/><path fill="#FBBC05" d="M10.4 28.7A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.8-6z"/><path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2.1 1.4-4.9 2.3-8.4 2.3-6.3 0-11.7-4.1-13.6-9.9l-7.8 6C6.5 42.6 14.6 48 24 48z"/></svg>
      {{ busy ? 'Waiting for Google' : 'Continue with Google' }}
    </button>
    <button v-if="providers.includes('apple')" type="button" class="pop-auth__btn pop-auth__btn--secondary" :disabled="busy" data-test="apple-button" @click="apple">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#000" aria-hidden="true"><path d="M16.37 12.65c.02 2.6 2.28 3.46 2.31 3.47-.02.06-.36 1.24-1.19 2.45-.72 1.05-1.46 2.09-2.64 2.11-1.15.02-1.52-.68-2.84-.68-1.32 0-1.73.66-2.82.7-1.13.04-2-1.13-2.72-2.17-1.48-2.14-2.61-6.04-1.09-8.68a4.22 4.22 0 0 1 3.56-2.16c1.11-.02 2.16.75 2.84.75.68 0 1.95-.93 3.29-.79.56.02 2.13.23 3.14 1.7-.08.05-1.87 1.1-1.84 3.3zM14.2 5.94c.6-.73 1.01-1.74.9-2.75-.87.04-1.92.58-2.54 1.31-.56.65-1.05 1.68-.92 2.67.97.08 1.96-.49 2.56-1.23z"/></svg>
      {{ busy ? 'Waiting for Apple' : 'Continue with Apple' }}
    </button>
    <div v-if="error" class="pop-auth__err">{{ error }}</div>
    <div class="pop-auth__or"><span></span>or<span></span></div>
  </div>
</template>

<script>
import { enabledProviders, loadGoogleIdentity, requestGoogleIdentityCode } from '@/utils/google-identity'
import { loadAppleIdentity, requestAppleIdentity } from '@/utils/apple-identity'

// "Continue with Google" / "Continue with Apple" (SOCIAL_LOGIN_PROVIDERS define, each provider only
// when its client id is configured). Emits `google` with the one-time code and `apple` with
// `{ code, name, nonce }`; the page does the exchange.
export default {
  name: 'SocialButtons',
  props: { busy: { type: Boolean, default: false } },
  data() {
    return { providers: enabledProviders(), error: '' }
  },
  mounted() {
    if (this.providers.includes('google')) loadGoogleIdentity().catch((e) => console.log(e))
    if (this.providers.includes('apple')) loadAppleIdentity().catch((e) => console.log(e))
  },
  methods: {
    apple() {
      this.error = ''
      requestAppleIdentity()
        .then((result) => this.$emit('apple', result))
        .catch((e) => {
          if (!e.popupClosed) {
            console.log(e)
            this.error = "Apple sign-in didn't complete. Please try again."
          }
        })
    },
    google() {
      this.error = ''
      requestGoogleIdentityCode()
        .then((code) => this.$emit('google', code))
        .catch((e) => {
          if (!e.popupClosed) {
            console.log(e)
            this.error = "Google sign-in didn't complete. Please try again."
          }
        })
    },
  },
}
</script>

<style scoped>
.social-buttons { display: grid; gap: 12px; margin-top: 4px; }
.social-buttons .pop-auth__or { margin: calc(var(--auth-or-gap) - 12px) 0 var(--auth-or-gap); }
</style>
